var map = {
	"./partners_0.png": "0bab",
	"./partners_1.png": "3762",
	"./partners_2.png": "0d51",
	"./partners_3.png": "e931",
	"./partners_4.png": "73c5",
	"./partners_5.png": "0d0b",
	"./partners_6.png": "adab",
	"./partners_7.png": "72b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da4a";